
export const SET_USER_HASH = '[User_hash] Set user auto liquidation hash';
export class SetUserHash {
  static readonly type = SET_USER_HASH;

  constructor(public hash: string) {
  }
}
